import * as moment from 'moment';
import { TIME_FORMATS } from '@config/index';

/**
 * Function return dateTime moment.js object which contains local date
 * regardless of local timezone. Time is set to zero.
 * e.g. 20 Feb at 8PM in Charlotte EST (GMT-5) it still returns moment('2019-02-20T00:00:00.000Z').
 * (note that new Date().toISOString() will return 21Feb)
 */
export const getStartOfLocalDay = (date?: string): any =>
  moment(date).utcOffset(0, true).startOf('day');

/**
 * Function return dateTime string in ISO format which contains local date
 * regardless of local timezone. Time is set to zero.
 * e.g. 20 Feb at 8PM in Charlotte EST (GMT-5) it still returns 2019-02-20T00:00:00.000Z.
 * (note that new Date().toISOString() will return 21Feb)
 */
export const getStartOfLocalDayISOString = (date?: string): string =>
  getStartOfLocalDay(date).toISOString();

export const convertUTCtoDate = (
  date: string,
  format: TIME_FORMATS = TIME_FORMATS.YYYYMMDD,
): string => moment(date).local().format(format);
